import { createContext } from "react";

import { Theme } from "@/shared/lib/hooks/useTheme";

export interface ThemeContextProps {
  theme?: Theme;
  setTheme?: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextProps>({});
